/** 汎用部品は複数画面で共有するので、計装属性は呼び出し元から受け取って素通しする。 */
export type AnalyticsAttrs = {
  "data-analytics-id"?: string;
  "data-analytics-ignore"?: boolean;
};

export function pickAnalyticsAttrs(props: AnalyticsAttrs): AnalyticsAttrs {
  return {
    "data-analytics-id": props["data-analytics-id"],
    "data-analytics-ignore": props["data-analytics-ignore"],
  };
}
